import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: '¿Qué formas de pago puedo usar?',
      answer: 'Aceptamos Mercado Pago (tarjetas de crédito y débito, saldo MP, pago en efectivo por redes habilitadas) y transferencia bancaria.',
    },
    {
      question: 'Si pago por transferencia, ¿qué debo hacer?',
      answer: (
        <div className="space-y-2">
          <ul className="list-disc list-inside space-y-1">
            <li>Tenés 12 horas para realizar y enviar el comprobante.</li>
            <li>Si el pedido no se acredita dentro de las 12 h, la orden se cancela automáticamente.</li>
            <li>
              Enviá el comprobante indicando número de orden a{' '}
              <a href="mailto:info@decohomesinrival.com.ar" className="text-[#2d3c5d] hover:underline font-semibold">
                info@decohomesinrival.com.ar
              </a>
            </li>
          </ul>
        </div>
      ),
    },
    {
      question: '¿Cuál es el costo de envío?',
      answer: 'Se calcula según ubicación y monto de compra y se muestra en el checkout antes de pagar.',
    },
    {
      question: '¿Hay demora en la entrega?',
      answer: 'Manejamos un plazo de preparación/despacho de 7 a 10 días hábiles desde la confirmación del pago.',
    },
    {
      question: '¿Dónde puedo recibir mi pedido?',
      answer: 'Realizamos envíos a todo el país a través de OCA (a domicilio o a sucursal OCA).',
    },
    {
      question: '¿Cuánto tarda en llegar?',
      answer: 'Una vez despachado, la entrega demora en general 3 a 5 días hábiles (según destino y operador).',
    },
    {
      question: '¿Puedo retirar mi pedido en un punto físico?',
      answer: 'Por el momento no ofrecemos retiro por depósito. Si habilitamos retiro en local, lo informaremos en el checkout y en nuestras redes.',
    },
    {
      question: '¿Cuál es el plazo para cambios?',
      answer: 'Podés solicitar el cambio dentro de los 10 días corridos posteriores a recibir la compra. El producto debe estar sin uso, con etiquetas y empaque original.',
    },
    {
      question: '¿Qué hago si el producto llega dañado o con un problema?',
      answer: (
        <p>
          Escribinos a{' '}
          <a href="mailto:info@decohomesinrival.com.ar" className="text-[#2d3c5d] hover:underline font-semibold">
            info@decohomesinrival.com.ar
          </a>{' '}
          con el número de orden, una descripción del inconveniente y fotos (si aplica). Te respondemos con los pasos a seguir.
        </p>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h1 className="text-4xl font-bold text-[#2d3c5d] mb-4">Preguntas Frecuentes</h1>
          <p className="text-gray-600">
            Encontrá respuestas a las consultas más comunes sobre nuestros productos y servicios
          </p>
        </div>

        {/* FAQs */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-200 last:border-0">
              <button
                onClick={() => toggleQuestion(index)}
                className="w-full px-6 py-5 flex items-center justify-between hover:bg-gray-50 transition text-left"
              >
                <h3 className="text-lg font-semibold text-[#2d3c5d] pr-4">
                  {faq.question}
                </h3>
                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5 text-[#2d3c5d] flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-[#2d3c5d] flex-shrink-0" />
                )}
              </button>

              {openIndex === index && (
                <div className="px-6 pb-5 text-gray-700">
                  {typeof faq.answer === 'string' ? (
                    <p>{faq.answer}</p>
                  ) : (
                    faq.answer
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contacto */}
        <div className="mt-8 bg-[#2d3c5d] rounded-lg p-8 text-white">
          <h2 className="text-2xl font-bold mb-4">¿No encontraste lo que buscabas?</h2>
          <p className="mb-4" style={{ color: '#eddacb' }}>
            Si tenés otras consultas, no dudes en contactarnos. Estamos para ayudarte.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="mailto:info@decohomesinrival.com.ar"
              className="inline-flex items-center justify-center px-6 py-3 rounded-lg font-semibold transition"
              style={{
                backgroundColor: '#eddacb',
                color: '#2d3c5d',
              }}
            >
              Enviar consulta por email
            </a>
            <Link
              to="/contacto"
              className="inline-flex items-center justify-center px-6 py-3 rounded-lg font-semibold border-2 transition"
              style={{
                borderColor: '#eddacb',
                color: '#eddacb',
              }}
            >
              Formulario de contacto
            </Link>
          </div>
        </div>

        {/* Botón volver */}
        <div className="mt-8">
          <Link
            to="/"
            className="inline-block px-6 py-3 rounded-lg font-semibold text-white transition"
            style={{ backgroundColor: '#2d3c5d' }}
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
